<template lang="pug">
ib-col(class="flex")
    ib-table-basic(
        class="socket outsety-24 shrink"
        :data="position",
        root="window",
        root-margin="256px",
    )
        ib-table-col(
            width="8ch",
        ) {{ $t('ib_symbol') }}    
        ib-table-col(
            width="36ch",
        ) {{ $t('product_description') }}
        ib-table-col(
            width="16ch",
            numeric
        ) {{ $t('Bid_Size') }}
        ib-table-col(
            width="16ch",
            numeric
        ) {{ $t('Bid_Price') }}
        ib-table-col(
            width="16ch",
            numeric
        ) {{ $t('Ask_price') }}
        ib-table-col(
            width="16ch",
            numeric
        ) {{ $t('Ask_Size') }}
        ib-table-col(
            width="24ch",
            numeric
        ) {{ $t('time') }}
        template(v-slot:empty)
            ib-progress-linear(v-if="loading")
            p(
                v-else-if="error",
                v-text="$t('Failed_to_get_contracts')"
            )
            p(
                v-else,
                v-text="$t('No_contracts_found')"
            )
        template(v-slot:body="pos")
            td(:title="pos.ticker")
                span(
                    v-text="pos.ticker",
                    class="end-8 text-bold"
                )
            td(:title="pos.desc") {{ pos.desc }}
            td(:title="posMd[88] || ''", v-num.raw="posMd[88]")
            td(:title="posMd[84] || ''", v-num.raw="posMd[84]")
            td(:title="posMd[86] || ''", v-num.raw="posMd[86]")
            td(:title="posMd[85] || ''", v-num.raw="posMd[85]")
            td(:title="time", v-num.raw="time")
</template>

<script>
    import { mapGetters } from 'vuex'

    import api from '@ibkr/clientportal.common/src/api/index.js'

    //const MD_FIELDS = [ '88', '84', '85', '86' ];
    const MD_FIELDS = [ '88', '84', '85', '86', '31' ];
    const subscribeThrottle = 100;
    const unsubscribeThrottle = 2000;
    const DEFAULT_EXCHANGE = 'EUIBSI';

    export default {
        name: 'WSTable',

        props: {
            position: Array, 
            view: Boolean
        },

        data() {
            return {
                loading: true,
                error: undefined,
                time: undefined
            }
        },

        methods: {
            getNow() {
                let d = $date.iso($date.local());
                d = d.slice(0, d.length - 5).replace(/-/g, "").replace(/T/, " ")
                this.time = d;
            }
        },

        computed: {
            ...mapGetters({
                md: 'iserverData/marketData'
            }),
            
            posMd() {
                return this.md[this.position[0].conid + '@EUIBSI'] || {};
            }
        },
        mounted() {
            setTimeout(()=> {
                this.$emit('hideTable');
            }, 300000)
        },
        watch: {
            //checking conid for testing
            'posMd.conid': {
                handler: function() {
                    //this.getNow();
                }
            },
            'posMd.88': {
                handler: function() {
                    this.getNow();
                }
            },
            'posMd.84': {
                handler: function() {
                    this.getNow();
                }
            },
            'posMd.85': {
                handler: function() {
                    this.getNow();
                }
            },
            'posMd.86': {
                handler: function() {
                    this.getNow();
                }
            },
        }
    }
</script>

<style lang="less">
.socket {
    width: calc(100% - 16px);
    table {
        border-top: 1px solid rgba(0,0,0,0.1);
        border-bottom: 1px solid rgba(0,0,0,0.1);
        border-left: 1px solid rgba(0,0,0,0.1);
    }
    th {
        border-right: 1px solid rgba(0,0,0,0.1);
        background-color: #dcdcde;
        color: #000;
        font-weight: bold;
    }
    td {
        border-right: 1px solid rgba(0,0,0,0.1);
    }
}
</style>